import { getFetchOptions } from "../../utils";
export function useSetsApi() {
    /**
     * Единый метод обновления черновика сета
     */
    async function updateDraft(params) {
        const response = await fetch('/api/user_sets/constructor/update', getFetchOptions(params, true));
        return await response.json();
    }
    async function addItem(id) {
        return updateDraft({ action: 'add_item', id });
    }
    async function replaceItem(index, offerId) {
        return updateDraft({ action: 'replace_item', index, id: offerId });
    }
    async function removeItem(index) {
        return updateDraft({ action: 'remove_item', index });
    }
    async function rename(name) {
        return updateDraft({ action: 'rename', name });
    }
    /**
     * Сохранение черновика сета в профиль
     */
    async function saveSet(name, ids, uuid) {
        const response = await fetch('/api/user_sets/constructor/save', getFetchOptions({ name, ids, uuid }, true));
        return await response.json();
    }
    return {
        addItem,
        replaceItem,
        removeItem,
        rename,
        saveSet,
    };
}
